import IService from "../service";
import ModalAlert from "./models/alert.model";

const TYPE_INFO = 'info';
const TYPE_SUCCESS = 'success';
const TYPE_ERROR = 'error';
const TYPE_WARNING = 'warning';

/**
 * @property $store {RepositoryManager}
 */
export default class AlertsService extends IService {
    /**
     * Getter
     * @returns {RepositoryManager}
     */
    get $store() {
        return this.config.repositories;
    }

    /**
     * Show alert
     * @param type {string}
     * @param message {string}
     * @param [timeout] {int}
     * @returns {ModalAlert}
     */
    show(type, message, timeout = 5000) {
        return new ModalAlert(
            this.$store.modals.addAlert(
                type,
                message,
                timeout
            )
        );
    }

    /**
     * Info alert
     * @param message {string}
     * @param [timeout] {int}
     * @returns {ModalAlert}
     */
    info(message, timeout) {
        return this.show(TYPE_INFO, message, timeout);
    }

    /**
     * Success alert
     * @param message {string}
     * @param [timeout] {int}
     * @returns {ModalAlert}
     */
    success(message, timeout) {
        return this.show(TYPE_SUCCESS, message, timeout);
    }

    /**
     * Error alert
     * @param message {string}
     * @param [timeout] {int}
     * @returns {ModalAlert}
     */
    error(message, timeout) {
        return this.show(TYPE_ERROR, message, timeout);
    }

    /**
     * Warning alert
     * @param message {string}
     * @param [timeout] {int}
     * @returns {ModalAlert}
     */
    warning(message, timeout) {
        return this.show(TYPE_WARNING, message, timeout);
    }

    /**
     * Hide all alerts
     */
    hideAll() {
        this.$store.modals
            .removeAllAlerts()
            .catch(() => false);
    }
}